import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'trips_json';

function loadTrips() {
  const json = localStorage.getItem(LOCAL_KEY);
  let trips;
  if (json) {
    try {
      trips = JSON.parse(json);
    } catch {
      trips = [];
    }
  } else {
    trips = [];
  }
  return trips;
}

function saveTrips(trips) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(trips));
}

const initialState = {
  trips: loadTrips(),
  filtered: loadTrips(),
};

const tripSlice = createSlice({
  name: 'trips',
  initialState,
  reducers: {
    addTrip(state, action) {
      state.trips.push(action.payload);
      state.filtered = state.trips;
      saveTrips(state.trips);
    },
    editTrip(state, action) {
      const idx = state.trips.findIndex(t => t.id === action.payload.id);
      if (idx !== -1) {
        state.trips[idx] = action.payload;
        state.filtered = state.trips;
        saveTrips(state.trips);
      }
    },
    removeTrip(state, action) {
      state.trips = state.trips.filter(t => t.id !== action.payload);
      state.filtered = state.trips;
      saveTrips(state.trips);
    },
    assignRepToTrip(state, action) {
      const { tripId, repId } = action.payload;
      const trip = state.trips.find(t => t.id === tripId);
      if (trip) {
        trip.assignedRepId = repId;
        saveTrips(state.trips);
      }
    },
    assignRouteToTrip(state, action) {
      const { tripId, routeId } = action.payload;
      const trip = state.trips.find(t => t.id === tripId);
      if (trip) {
        trip.assignedRouteId = routeId;
        saveTrips(state.trips);
      }
    },
    assignStockToTrip(state, action) {
      const { tripId, stock } = action.payload; // stock: array of {productId, quantity}
      const trip = state.trips.find(t => t.id === tripId);
      if (trip) {
        trip.stock = stock;
        saveTrips(state.trips);
      }
    },
    assignClientsToTrip(state, action) {
      const { tripId, clients } = action.payload; // clients: array of clientIds
      const trip = state.trips.find(t => t.id === tripId);
      if (trip) {
        trip.clients = clients;
        saveTrips(state.trips);
      }
    },
  },
});

export const { addTrip, editTrip, removeTrip, assignRepToTrip, assignRouteToTrip, assignStockToTrip, assignClientsToTrip } = tripSlice.actions;
export default tripSlice.reducer; 